import { render, staticRenderFns } from "./Rotas.vue?vue&type=template&id=29027052&scoped=true"
import script from "./Rotas.vue?vue&type=script&lang=js"
export * from "./Rotas.vue?vue&type=script&lang=js"
import style0 from "./Rotas.vue?vue&type=style&index=0&id=29027052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29027052",
  null
  
)

export default component.exports